import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSend: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSend"><Path d="M20.9019 4.67541C21.2226 3.70113 20.2981 2.77664 19.3238 3.09728L2.04283 8.7847C0.877044 9.16837 0.904585 10.827 2.08248 11.1717L10.3947 13.6046L12.8275 21.9167C13.1722 23.0946 14.8308 23.1222 15.2145 21.9564L20.9019 4.67541Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSend;
